import { render, staticRenderFns } from "./AllowancesPlanDetailsDelete.vue?vue&type=template&id=c33ad0e2&scoped=true&"
import script from "./AllowancesPlanDetailsDelete.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetailsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33ad0e2",
  null
  
)

export default component.exports